import { FontFaceClasses_FontFamily_$ctor_9401DF4, FontFaceClasses_AscentDescentOverride_$ctor_9401DF4, FontFaceClasses_FontVariationSettings_$ctor_9401DF4, FontFaceClasses_LineGapOverride_$ctor_9401DF4, FontFaceClasses_UnicodeRange_$ctor_9401DF4, FontFaceClasses_SizeAdjust_$ctor_9401DF4, FontFaceClasses_FontWeight_$ctor_9401DF4, FontFaceClasses_FontStretch_$ctor_9401DF4, FontFaceClasses_FontStyle_$ctor_9401DF4, FontFaceClasses_FontDisplay_$ctor_9401DF4, FontFaceClasses_Src_$ctor_9401DF4 } from "../Types/FontFace.fs.js";
import { Property_FontFaceProperty } from "../Types/MasterTypes.fs.js";

export const Src = FontFaceClasses_Src_$ctor_9401DF4(new Property_FontFaceProperty(12));

export const FontDisplay = FontFaceClasses_FontDisplay_$ctor_9401DF4(new Property_FontFaceProperty(2));

export const FontStyle = FontFaceClasses_FontStyle_$ctor_9401DF4(new Property_FontFaceProperty(5));

export const FontStretch = FontFaceClasses_FontStretch_$ctor_9401DF4(new Property_FontFaceProperty(4));

export const FontWeight = FontFaceClasses_FontWeight_$ctor_9401DF4(new Property_FontFaceProperty(6));

export const SizeAdjust = FontFaceClasses_SizeAdjust_$ctor_9401DF4(new Property_FontFaceProperty(11));

export const UnicodeRange = FontFaceClasses_UnicodeRange_$ctor_9401DF4(new Property_FontFaceProperty(13));

export const LineGapOverride = FontFaceClasses_LineGapOverride_$ctor_9401DF4(new Property_FontFaceProperty(10));

export const FontVariationSettings = FontFaceClasses_FontVariationSettings_$ctor_9401DF4(new Property_FontFaceProperty(9));

export const AscentOverride = FontFaceClasses_AscentDescentOverride_$ctor_9401DF4(new Property_FontFaceProperty(0));

export const DescentOverride = FontFaceClasses_AscentDescentOverride_$ctor_9401DF4(new Property_FontFaceProperty(1));

export const FontFamily = FontFaceClasses_FontFamily_$ctor_9401DF4(new Property_FontFaceProperty(3));

